import * as React from "react";

import './SecondaryBar.pcss';
import {useEffect, useRef} from "react";

interface Props {
  title:string;
  subTitle?:string;
  buttonAction:()=>void;
  buttonLabel?:string;
  children?:any;
}

export function SecondaryBar(props:Props) {

  const backRef = useRef(null);
  useEffect(()=>{
    if(backRef && backRef.current) {
      // @ts-ignore
      backRef.current.focus();
    }
  });

  let buttonProps = {
    onClick:props.buttonAction,
    tabIndex:0
  }
  buttonProps['aria-label'] = props.buttonLabel ? props.buttonLabel : "Back to previous page";

  return (
    <header>
    <div className={"secondary-bar"}>
      <div className={"lft"}>
        <div className={"lft-back"}><button ref={backRef} {...buttonProps}><span className="material-symbols-outlined">arrow_back_ios</span></button></div>
        <div className={"lft-head"}>
          <h1>{props.title}</h1>
          {props.subTitle && <p>{props.subTitle}</p>}
        </div>
      </div>
      <div className={"rt"}>
        {props.children?props.children:null}
      </div>
    </div>
    </header>
  );
}
